import { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { BiSolidArchiveIn, BiSolidArchiveOut } from 'react-icons/bi';
import { FaRegCopy } from 'react-icons/fa';
import { archiveOrders, orders } from '../../../Services/AdminServices/AdminCommissionServices';
import DataTables from '../../Main/DataTable/DataTables';
import toast from 'react-hot-toast';

const exportToCSV = (data, columns, filename = "orders.csv") => {
    if (!data.length) return;

    // sirf named columns lo (icon wala skip ho jaayega)
    const exportableColumns = columns.filter(col => col.name);

    const headers = exportableColumns.map(col => col.name);
    const csvRows = [headers.join(",")];

    data.forEach(row => {
        const values = exportableColumns.map(col => {
            let val = "";

            try {
                if (col.selector) {
                    val = col.selector(row) ?? "";
                } else if (col.cell) {
                    const cellVal = col.cell(row);
                    if (typeof cellVal === "string" || typeof cellVal === "number") {
                        val = cellVal;
                    } else if (cellVal?.props?.children) {
                        const text = Array.isArray(cellVal.props.children)
                            ? cellVal.props.children.map(c => (typeof c === "string" ? c : "")).join("")
                            : (typeof cellVal.props.children === "string" ? cellVal.props.children : "");
                        val = text;
                    }
                }
            } catch {
                val = "";
            }

            // ✅ Big number (Order ID fix)
            if (typeof val === "number" || /^[0-9]{10,}$/.test(val)) {
                val = `="${val}"`; // Excel safe
            }

            return `"${val}"`;
        });

        csvRows.push(values.join(","));
    });

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};





const Orders = () => {
    const [data, setData] = useState([]);
    const [archiveData, setArchiveData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isArchive, setIsArchive] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        toast.success("Copy to clipboard")
    };

    const columns = [
        {
            width: "20px",
            cell: row => (
                <div className="d-flex align-items-center gap-2">

                    {row.user_referrer?.email && (
                        <FaRegCopy
                            size={18}
                            color="black"
                            style={{ cursor: "pointer" }}
                            onClick={() => copyToClipboard(row.user_referrer?.email)}
                        />
                    )}
                </div>
            )
        },
        {
            name: "Referral User",
            width: "200",
            selector: row => row?.user_referrer?.email,
        },
        { name: 'Referal Code', selector: row => row.referrer_referral_code },
        { name: 'Order Id', selector: row => row.shopify_order_id },
        { name: 'Shopify User Email', selector: row => row.contact_email },
        { name: 'Referral %', selector: row => row.subtotal_price },
        { name: 'Total Price', selector: row => row.total_price },
        { name: 'Status', selector: row => row.status },
    ];

    const archiveColumns = [
        {
            name: 'Referal User',
            cell: row => (
                <div className="d-flex align-items-center gap-2">
                    {row.user_referrer?.email && (
                        <FaRegCopy
                            size={18}
                            style={{ cursor: "pointer" }}
                            onClick={() => copyToClipboard(row.user_referrer?.email)}
                        />
                    )}
                    <span>{row.user_referrer?.email}</span>
                </div>
            )
        },
        { name: 'Referal Code', selector: row => row.referrer_referral_code },
        { name: 'Order Id', selector: row => row.shopify_order_id },
        { name: 'Shopify User Email', selector: row => row.contact_email },
        { name: 'Referral %', selector: row => row.subtotal_price },
        { name: 'Total Price', selector: row => row.total_price },
        { name: 'Deleted At', selector: row => row.deleted_at },
    ];

    const getOrders = async () => {
        setLoading(true)
        const response = await orders();
        if (response?.code === 200) {
            setData(response?.result?.sh_orders?.original?.data)
            setLoading(false)
        }
    }

    const getArchiveOrders = async () => {
        setLoading(true)
        const response = await archiveOrders();
        if (response?.code === 200) {
            setArchiveData(response?.result?.sh_orders?.original?.data)
            setLoading(false)
        }
    }

    useEffect(() => { getOrders(); getArchiveOrders(); }, [])

    // ✅ Filtered data based on search
    const filteredData = (isArchive ? archiveData : data).filter(item =>
        Object.values(item).some(val =>
            String(val ?? '').toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const handleExport = () => {
        exportToCSV(
            filteredData,
            isArchive ? archiveColumns : columns,
            isArchive ? "archive_orders.csv" : "orders.csv"
        );
    };

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg">
                        <h3 className='fw-bold mb-0'>Shopify Orders</h3>
                        <p className='text-muted'>Manage shopify orders </p>
                    </div>

                    <div className="col-auto">
                        <Form.Control
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="col-auto">
                        <Button onClick={handleExport}>
                            Export CSV
                        </Button>
                    </div>
                    <div className="col-auto">
                        <Button onClick={() => { setIsArchive(!isArchive) }}>
                            {isArchive ? <BiSolidArchiveIn size={22} /> : <BiSolidArchiveOut size={22} />}
                        </Button>
                    </div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="col-lg-12">
                            <DataTables
                                filter={false}
                                columns={isArchive ? archiveColumns : columns}
                                data={filteredData} // ✅ send filtered data to table
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default Orders;
